import React from "react";

const LoadingDropdown = ({
  label,
  name,
  value,
  onChange,
  disabled = false,
  isLoading = false,
  showSpinnerOnLabel = true,
  className = "punchedAttendence-dropdown",
  labelClassName = "punchedAttendence-label",
  children, // <option> tags passed from parent
}) => {
  return (
    <>
      <label className={labelClassName}>
        {label}
        {isLoading && showSpinnerOnLabel && (
          <span className="inline-block w-3 h-3 ml-1.5 border-2 border-blue-200 border-t-blue-500 rounded-full animate-spin align-middle" />
        )}
      </label>

      {isLoading ? (
        <div className="h-[38px] w-full rounded-md bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-pulse" />
      ) : (
        <select
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={className}
        >
          {children}
        </select>
      )}
    </>
  );
};

export default LoadingDropdown;